import React, { Fragment, useEffect } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux'

import { getInspectores } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import { getPuestos } from '../../../redux/DucksUnidadInspeccion/PuestosDuck'
import { getCoches } from '../../../redux/DucksUnidadInspeccion/VehiculosDuck'

import { registrarUsuarioAccionUI, updateLogin } from '../../../redux/UsuarioDucks';

import { withRouter } from 'react-router-dom'
import estilos from './InspectoresFormComponent.module.css'
import { insertInspector, updateInspector } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import moment from 'moment'

import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import Swal from 'sweetalert2';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';

const InspectoresFormComponent = (props) => {

    const dispatch = useDispatch()

    const puestos = useSelector(store => store.Puestos.puestos)
    const inspectores = useSelector(store => store.Inspectores.inspectores)
    const vehiculos = useSelector(store => store.Vehiculos.coches)

    const [vehiculosState, setVehiculosState] = React.useState([])

    const [image, setImage] = React.useState(null)
    const [isImagePicked, setIsImagePicked] = React.useState()
    const [imgData, setImgData] = React.useState(null);
    const reader = new FileReader();

    const onChangeImage = (e) => {
        setImage(e.target.files[0]) //input
        setIsImagePicked(true)
        reader.addEventListener("load", () => {
            setImgData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
    }

    const inspectorModify = props.inspectorModify
    const [initialStateFormik, setInitialStateFormik] = React.useState({
        idinspector: '',
        idcatalogopuestos: '',
        consulta: false,
        idautomovil: '',
        nombre: '',
        apellidos: '',
        titulo: '',
        estatus: '',
        laptop: '',
        celular: '',
        tarjeta: '',
        vehiculo: '',
        imagenpath: '',
        tutor: '',
        acreditacion: '',
        iscapacitacion: '',
        contactoemergencia: '',
        telefonoemergencia: '',
        numerosegurosocial: '',
        tiposangre: '',
        alergias: ''
    })

    React.useEffect(() => {
        dispatch(getPuestos())
        dispatch(getCoches())
        dispatch(getInspectores())
    }, []);

    React.useEffect(() => {
        var aux = []
        inspectores.forEach((i) => {
            aux.push(parseInt(i.vehiculo))
        })

        let result = aux.filter((item, index) => {
            return aux.indexOf(item) === index;
        })

        setVehiculosState(result)
    }, [inspectores]);

    React.useEffect(() => {
        vehiculosState
    }, [vehiculosState]);

    React.useState(() => {
        if (inspectorModify !== null) {
            setInitialStateFormik({
                idinspector: inspectorModify.idinspector,
                idcatalogopuestos: inspectorModify.idcatalogopuestos,
                idautomovil: inspectorModify.idautomovil,
                nombre: inspectorModify.nombre,
                apellidos: inspectorModify.apellidos,
                titulo: inspectorModify.titulo,
                estatus: inspectorModify.estatus,
                laptop: inspectorModify.laptop,
                celular: inspectorModify.celular,
                tarjeta: inspectorModify.tarjeta,
                vehiculo: inspectorModify.vehiculo,
                imagenpath: inspectorModify.imagenpath,
                tutor: inspectorModify.tutor,
                acreditacion: inspectorModify.acreditacion,
                iscapacitacion: inspectorModify.iscapacitacion,
                contactoemergencia: inspectorModify.contactoemergencia,
                telefonoemergencia: inspectorModify.telefonoemergencia,
                numerosegurosocial: inspectorModify.numerosegurosocial,
                tiposangre: inspectorModify.tiposangre,
                alergias: inspectorModify.alergias,
                usuario: inspectorModify.login != null ? inspectorModify.login.usuario : null,
                //contraseña: inspectorModify.login != null ? inspectorModify.login.password : null,
                idlogin: inspectorModify.login != null ? inspectorModify.login.idlogin : null,
                isactivo: inspectorModify.isactivo,
                fechabaja: inspectorModify.fechabaja,
                fechaacreditacion: new Date(inspectorModify.fechaacreditacion).toISOString().split('T')[0],
                consulta: inspectorModify?.login?.idtipousuario == 13 ? true : false,
                login: inspectorModify?.login,
                contraseña: ''
            })
        }
    }, [inspectorModify])

    const AgregarCliente = async (values) => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        let hoy = new Date(fechaHoy).toISOString()
        await dispatch(actualizarLoadingApp_true())
        try {
            let dataLogin = {
                usuario: values?.usuario,
                password: values?.contraseña,
                idtipousuario: values.consulta ? 13 : values.idcatalogopuestos == "1" ? 5 : 4,
                idrol: 1,
                fechainscripcion: hoy,
            }
            let resultadoLogin = await dispatch(registrarUsuarioAccionUI(dataLogin))
            if (resultadoLogin == undefined) {
                Store.addNotification({
                    title: "Correo Electronico ya registrado!",
                    message: "Ingrese un Correo Electronico diferente",
                    type: "danger",
                    insert: "top",
                    container: "top-center",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true,
                    }
                });
                await dispatch(actualizarLoadingApp_false())
                return
            }
            let dataInspector = {
                idcatalogopuestos: Number(values?.idcatalogopuestos),
                idautomovil: Number(values?.idautomovil),
                nombre: values?.nombre,
                apellidos: values?.apellidos,
                titulo: values?.titulo,
                estatus: values?.acreditacion?.length > 0 ? "Acreditado" : null,
                laptop: values?.laptop,
                celular: Number(values?.celular),
                tarjeta: Number(values?.tarjeta),
                vehiculo: values?.idautomovil + '',
                tutor: Number(values?.tutor),
                //imagenpath: values?.imagenpath,
                acreditacion: values?.acreditacion,
                iscapacitacion: Number(values?.idcatalogopuestos) == 3 ? 1 : 0,
                contactoemergencia: values?.contactoemergencia,
                telefonoemergencia: values?.telefonoemergencia,
                numerosegurosocial: values?.numerosegurosocial,
                tiposangre: values?.tiposangre,
                alergias: values?.alergias,
                idlogin: resultadoLogin?.nuevoUsuario?.idlogin,
                isactivo: true,
                fechabaja: null,
                fechaacreditacion: new Date(values?.fechaacreditacion).toISOString()
            }
            let resInspector = await dispatch(insertInspector({ data: dataInspector, image: image }))
            if (resInspector.payload.data.data != null) {
                Swal.fire({
                    title: "Agregado",
                    text: "Inspector agregado correctamente",
                    icon: "success"
                });
            }
            props.onClose()
            await dispatch(actualizarLoadingApp_false())

        } catch (error) {
            await dispatch(actualizarLoadingApp_false())

        }

    }

    const ActualizarCliente = async (values) => {
        let dataLogin = {
            idlogin: values?.login?.idlogin,
            usuario: values?.usuario,
            idtipousuario: values.consulta ? 13 : values.idcatalogopuestos == "1" ? 5 : 4,
            idrol: 1,
        }
        if (values?.contraseña?.length > 0) dataLogin.password = values?.contraseña
        let resultadoLogin = await dispatch(updateLogin(dataLogin))

        let dataInspector = {
            idinspector: Number(values?.idinspector),
            idcatalogopuestos: Number(values?.idcatalogopuestos),
            idautomovil: Number(values?.idautomovil),
            nombre: values?.nombre,
            apellidos: values?.apellidos,
            titulo: values?.titulo,
            estatus: values?.acreditacion?.length > 0 ? "Acreditado" : null,
            laptop: values?.laptop,
            celular: Number(values?.celular),
            tarjeta: Number(values?.tarjeta),
            vehiculo: values?.idautomovil + '',
            tutor: Number(values?.tutor),
            //imagenpath: values?.imagenpath,
            acreditacion: values?.acreditacion,
            iscapacitacion: Number(values?.idcatalogopuestos) == 3 ? 1 : 0,
            contactoemergencia: values?.contactoemergencia,
            telefonoemergencia: values?.telefonoemergencia,
            numerosegurosocial: values?.numerosegurosocial,
            tiposangre: values?.tiposangre,
            alergias: values?.alergias,
            idlogin: resultadoLogin?.idlogin,
            isactivo: true,
            fechabaja: null,
            fechaacreditacion: new Date(values?.fechaacreditacion).toISOString()
        }
        let resInspector = await dispatch(updateInspector({ data: dataInspector }))
        if (resInspector.payload.data.data != null) {
            Swal.fire({
                title: "Atualización",
                text: "Inspector actualizado correctamente",
                icon: "success"
            });
        }
        props.onClose()
    }
    return (
        <Fragment>
            <div className='row'>
                <div className={`${estilos.contenedorBorder}`}>
                    <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>{
                            inspectorModify ?
                                "Editar inspector" :
                                "Registrar Inspector"
                        }</h1>
                    </div>
                    <Formik initialValues={initialStateFormik}
                        onSubmit={(values) => {
                            if (inspectorModify != null) ActualizarCliente(values)
                            else AgregarCliente(values)

                        }}>
                        {({ values }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>
                                    <div className="row">
                                        <div className="col">
                                            <div className={`${estilos.contenedorBorder}`}>
                                                <label>Subir imagen de perfil del Inspector</label><br></br>
                                                <Field type="file" className="form-control form-control-sm" name="file" accept="image/png,image/jpeg" onChange={onChangeImage} /><br /><br />
                                                <img width={'350px'} alt="..." className="playerProfilePic_home_tile img-fluid img-thumbnail" src={imgData} />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <label htmlFor="titulo">Título Académico/Profesión:</label><br />
                                            <Field as="select" name="titulo" className='form-control' required>
                                                <option value="">Seleccione Titulo</option>
                                                <option key={1} value={'Q.F.B.'}>Q.F.B.</option>
                                                <option key={2} value={'Ing.'}>Ing</option>
                                                <option key={3} value={'Biol.'}>Biol.</option>
                                                <option key={4} value={'Lic'}>Lic.</option>
                                            </Field>
                                            <ErrorMessage name="titulo" component="div" className={`${estilos.error}`} /><br />

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <label htmlFor="nombre">Nombre:</label><br />
                                                    <Field type="text" name="nombre" className='form-control' required>
                                                    </Field>
                                                    <ErrorMessage name="nombre" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                                <div className='col-md-6'>
                                                    <label htmlFor="apellidos">Apellidos:</label><br />
                                                    <Field type="text" name="apellidos" className='form-control' required>
                                                    </Field>
                                                    <ErrorMessage name="apellidos" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <label htmlFor="numerosegurosocial">NSS del IMSS:</label><br />
                                                    <Field type="text" name="numerosegurosocial" className='form-control' >
                                                    </Field>
                                                    <ErrorMessage name="numerosegurosocial" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                                <div className='col-md-6'>
                                                    <label htmlFor="tiposangre">Tipo de Sangre:</label><br />
                                                    <Field type="text" name="tiposangre" className='form-control'>
                                                    </Field>
                                                    <ErrorMessage name="tiposangre" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <label htmlFor="alergias">Alergias:</label><br />
                                                <Field type="text" name="alergias" className='form-control'>
                                                </Field>
                                                <ErrorMessage name="alergias" component="div" className={`${estilos.error}`} /><br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="contactoemergencia">Contacto de Emergencia:</label><br />
                                            <Field type="text" name="contactoemergencia" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="contactoemergencia" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor="telefonoemergencia">Teléfono de Emergencia:</label><br />
                                            <Field type="text" name="telefonoemergencia" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="telefonoemergencia" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="usuario">Correo Electronico:</label><br />
                                            <Field type="text" name="usuario" className='form-control' required>
                                            </Field>
                                            <ErrorMessage name="usuario" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor="contraseña">Contraseña:</label><br />
                                            <Field type="password" name="contraseña" className='form-control' validate={(value, props) => {
                                                const { idinspector } = values.idinspector;
                                                if (idinspector !== null && idinspector !== undefined && !value) {
                                                    return 'La contraseña es requerida';
                                                }
                                                return undefined;
                                            }}>
                                            </Field>
                                            <ErrorMessage name="contraseña" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="celular">Celular:</label><br />
                                            <Field type="text" name="celular" className='form-control' required>
                                            </Field>
                                            <ErrorMessage name="celular" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor="tarjeta">Tarjeta de Gasolina:</label><br />
                                            <Field type="number" name="tarjeta" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="tarjeta" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="consulta">Solo Consulta:</label><br />
                                            <Field type="checkbox" className="form-check-input" name="consulta" />
                                            <label className="form-check-label" for="consulta">
                                                Solo Consulta
                                            </label>
                                            <ErrorMessage name="consulta" component="div" className={`${estilos.error}`} /><br />
                                            <br />
                                        </div>
                                    </div>
                                    {values.consulta == false &&
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <label htmlFor="idcatalogopuestos">Puesto:</label><br />
                                                <Field as="select" name="idcatalogopuestos" className="form-select" required>
                                                    <option value="">Seleccione Puesto</option>
                                                    {
                                                        puestos.map((puesto, index) => (
                                                            <option key={index} value={puesto.idcatalogopuestos}>{puesto.nombre}</option>
                                                        ))
                                                    }
                                                </Field>
                                                <ErrorMessage name="idcatalogopuestos" component="div" className={`${estilos.error}`} /><br />
                                            </div>

                                            {
                                                values.idcatalogopuestos == "3" &&
                                                <div className='col-md-6'>
                                                    <label htmlFor="tutor">Tutor de capacitación:</label><br />
                                                    <Field as="select" name="tutor" className='form-control'>
                                                        <option value="">Seleccione Tutor</option>
                                                        {
                                                            inspectores.map((inspector, index) => {
                                                                if (inspector.iscapacitacion != 1) {
                                                                    return (<option value={inspector.idinspector}>{inspector.nombre} {inspector.apellidos}</option>)
                                                                }
                                                            })
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="tutor" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                            }
                                        </div>
                                    }
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="laptop">Número de Laptop:</label><br />
                                            <Field type="number" name="laptop" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="laptop" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor="idautomovil">Vehículo Asignado:</label><br />
                                            <Field as="select" name="idautomovil" className='form-control' >
                                                <option value="">Seleccione Vehiculo</option>
                                                {
                                                    vehiculos.map((vehiculo, index) => {
                                                        return (
                                                            <option key={index} value={vehiculo.idautomovil}>Auto:{vehiculo.marca} {vehiculo.modelo} {vehiculo.color} {vehiculo.marca} {vehiculo.placas}</option>
                                                        )
                                                    })
                                                }
                                            </Field>
                                            <ErrorMessage name="idautomovil" component="div" className={`${estilos.error}`} />
                                            <br />
                                        </div>

                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="acreditacion">Número de acreditación:</label><br />
                                            <Field type="text" name="acreditacion" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="acreditacion" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor="fechaacreditacion">Fecha de acreditación:</label><br />
                                            <Field type="date" name="fechaacreditacion" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="fechaacreditacion" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <button type="submit" className='btn btn-lg btn-success'>
                                            {
                                                inspectorModify ?
                                                    "Guardar cambios" :
                                                    "Agregar Inspector"
                                            }
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}

                    </Formik>
                </div>

            </div>

        </Fragment >
    )
}

export default withRouter(InspectoresFormComponent)